export var VERSION = '1.13.6';
//# sourceMappingURL=version.js.map